import { JID, Status } from '@bidi/chat-client';
import { ActionReducerMap } from '@ngrx/store';
import get from 'lodash/fp/get';
import partition from 'lodash/fp/partition';
import { DistributionGroup } from '../../../models';
import { imgs } from '../stubs/imgs';
import {
  ChatActionTypes,
  ChatLoginFailure,
  ChatLoginSuccess,
  CreateChannelsFromDistributionGroups,
  IncomingMessage,
  SelectChannel,
  SelectGroup,
  StatusChange
} from './actions';

export function status (state = null, { type, payload }: StatusChange) {
  switch (type) {
    case ChatActionTypes.STATUS_CHANGE:
      return payload;
    default:
      return state;
  }
}

export function userJid (state = null, { type, payload }: ChatLoginSuccess & ChatLoginFailure) {
  switch (type) {
    case ChatActionTypes.LOGIN_SUCCESS:
      return payload.jid;
    case ChatActionTypes.LOGIN_FAILURE:
      return null;
    default:
      return state;
  }
}

export function channels (
  state = [], { type, payload, timestamp }: CreateChannelsFromDistributionGroups & IncomingMessage
) {
  switch (type) {
    case ChatActionTypes.CREATE_CHANNELS_FROM_DISTRIBUTION_GROUPS:
      return state.concat(
        payload.groups.map(group => {
          const parent = payload.groups.find(g => g._id === group.parent);
          return {
            jid: `${group._id}@conference.${payload.host}`,
            name: parent ? group.name : 'General',
            groupId: group.parent || group._id,
            groupName: parent ? parent.name : group.name,
            groupchat: true,
            history: []
          };
        })
      );
    case ChatActionTypes.INCOMING_MESSAGE:
      if (payload.getChildText('error')) {
        return state;
      }

      const [jid, sender] = payload.attrs.from.split('/');
      const body = payload.getChildText('body');
      const delay = payload.getChild('delay');
      const [[chan], rest] = partition(ch => ch.jid === jid, state);
      return [
        {
          ...chan,
          history: chan.history.concat([{
            from: sender || jid,
            body: body,
            timestamp: delay ? new Date(delay.attr('stamp')) : timestamp,
            avatarUrl: imgs[jid]
          }])
        },
        ...rest
      ];
    default:
      return state;
  }
}

export function selectedGroup (state = null, { type, payload }: SelectGroup) {
  switch (type) {
    case ChatActionTypes.SELECT_GROUP:
      return get([0, 'groupId'], payload) || null;
    default:
      return state;
  }
}

export function selectedChannel (state = null, { type, payload }: SelectChannel) {
  switch (type) {
    case ChatActionTypes.SELECT_CHANNEL:
      return get(['jid'], payload) || null;
    default:
      return state;
  }
}

export interface State {
  userJid: JID;
  status: Status;
  channels: DistributionGroup[];
  selectedGroup: string;
  selectedChannel: string;
}

export const reducers: ActionReducerMap<State> = {
  userJid,
  status,
  channels,
  selectedGroup,
  selectedChannel
};
